<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                    <v-container>
                        <v-row class="mt-5">
                            <v-col cols="10" md="4" class="mt-n5 d-flex">
                                <v-select @change="searchProductList()" class='casilla_beige  text-body-2' v-model="tipo" :items="tipos" label="Tipo" dense rounded></v-select>
                            </v-col>
                            <v-col cols="10" md="5" class="mt-n5">
                                <v-alert class='text-caption' dense shaped text type="info">
                                    Selecciona Tipo de Inventario !!!
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-sheet>

            </v-row>
            <v-row class="mt-n7">
                <v-col cols="12">
                    <v-data-table :loading="progress" loading-text="Cargando....." dense height="400px" fixed-header
                    :search="search" :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" 
                    hide-default-footer class="elevation-1 text-size" @page-count="pageCount = $event" dark>
                    <template v-slot:item.st_codigo="{ item }">
                        <v-chip small>
                            {{ item.st_codigo }}
                        </v-chip>
                    </template>                    
                    <template v-slot:item.name_bodega="{ item }">
                        <div v-if="item.name_bodega!=''">
                            {{ item.name_bodega }}
                        </div>
                        <div v-else>
                            <v-icon small color="grey">do_not_disturb</v-icon>
                        </div>
                    </template>
                    <template v-slot:item.stock="{ item }">
                        <div v-if="parseFloat(item.stock)<=parseFloat(item.critico)">
                            <v-chip small color="red">
                                {{ item.stock }}
                            </v-chip>
                        </div>
                        <div v-else>
                            <v-chip small color="green">
                                {{ item.stock }}
                            </v-chip>
                        </div>
                    </template>                 
                </v-data-table>
                </v-col>
                <v-col cols="4">
                    <v-text-field class='text-caption' v-model="search" label="Buscar Producto" dense required></v-text-field>
                </v-col>
                <v-col cols="4"></v-col>
                <v-col cols="4" class="text-end">
                    <v-btn @click="descargarXLS()" small color="teal" dark rounded block>
                        <img valign="middle" src="@/assets/csv.png" width="16px" height="20px"/>
                        <span class="ml-2 mt-1">Exportar a Excel</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 26px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightgray;
    color:black
}
.col-color-blue-grey >>> th {
    background-color: #c5e3e7;
}
.casilla_beige {
    background-color: beige; 
    height: 30px;
    border: 1px solid lightgray;
}
.casilla_grey {
    background-color: lightgray ; 
    height: 30px;
    border: 1px solid lightgray;
}
</style>
<script>
import axios from "axios";
import exportXlsFile from 'export-from-json';
import exportFromJSON from 'export-from-json';
export default {
  name: 'Inventario',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    loading:false,
    headers: [
      { text: 'Sku', align: 'start', sortable: true, value: 'st_codigo' },
      { text: 'Barra', align: 'start', sortable: true, value: 'barra' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Marca', align: 'start', sortable: true, value: 'txt_marca' },
      { text: 'Modelo', align: 'start', sortable: true, value: 'modelo' },
      { text: 'Serie', align: 'start', sortable: true, value: 'serie' },
      { text: 'Stock', align: 'center', sortable: true, value: 'stock' },
      { text: 'Bodega', align: 'start', sortable: true, value: 'name_bodega' },
    ],
    items: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 1000000,
    progress:false,
    tipo:'Resumen',
    tipos:['Resumen', 'Detalle'],
    search:'',
    bloqueo:null,
  }),
  async mounted(){
    this.loading=true;
    this.user=localStorage.getItem('dops_myuser');
    this.apikey=localStorage.getItem('dops_apiKey');
    this.contrato=localStorage.getItem('dops_mycontrato');
    this.bloqueo = await this.myPermiso(5);
    if(parseInt(this.bloqueo)!=0){
        await this.searchProductList()
    }
    this.loading=false;
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    descargarXLS(){
      this.loading=true;
      let name_file = 'Inventario';
      let tbl_data = null;
      tbl_data = this.items;
      if(tbl_data.length!=0){
          const data = tbl_data;
          const fileName = name_file;
          const exportType = exportFromJSON.types.xls;
          exportXlsFile({ data, fileName, exportType })
      } else{
          console.log('Tabla sin datos')
      }
      this.loading=false;
    },
    async searchProductList(){
        this.loading=true;
        let temp_lista=[];
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user :  this.user,
            };
            let res;
            if(this.tipo=='Detalle'){
                res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/inventary/detail/',params,{headers});
            }
            if(this.tipo=='Resumen'){
                res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/inventary/resumen/',params,{headers});                
            }
            const datos = res.data;
            if(datos[0].existe=='si'){
                temp_lista = datos
            };
            this.items = temp_lista     
        } catch (error) {
            console.log(error)
        }
        this.loading=false;
    },


  }
}
</script>
